import React from "react";

export const REVIEW_STYLES = {
  "Unreviewed": "bg-stone-200 text-stone-600 border-stone-300",
  "Keep": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Review": "bg-amber-100 text-amber-800 border-amber-300",
  "Removal Candidate": "bg-rose-100 text-rose-800 border-rose-300",
};

export function ReviewChip({ status }) {
  const s = REVIEW_STYLES[status] || REVIEW_STYLES["Unreviewed"];
  return (
    <span className={`inline-block text-[11px] px-2 py-0.5 rounded-full border ${s}`} data-testid="review-chip">
      {status}
    </span>
  );
}

export function StatusChip({ value }) {
  if (value == null) return null;
  const v = String(value).toLowerCase();
  const style =
    v === "active"
      ? "bg-emerald-100 text-emerald-800 border-emerald-300"
      : v === "disabled" || v === "deleted" || v === "inactive" || v === "archived"
      ? "bg-stone-200 text-stone-600 border-stone-300"
      : "bg-sky-100 text-sky-800 border-sky-300";
  return <span className={`inline-block text-[11px] px-2 py-0.5 rounded-full border ${style}`}>{String(value)}</span>;
}

export function Empty({ children }) {
  return <div className="text-sm text-stone-400 italic py-8 text-center">{children}</div>;
}
